// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Shipping24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Shipping24: FC<Shipping24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M7 20a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 4 17H1.5l.45-2h2.825a3 3 0 0 1 1-.738A2.915 2.915 0 0 1 7 14c.433 0 .842.088 1.225.262a3 3 0 0 1 1 .738H13.4l2.1-9H4.55l.1-.425c.1-.467.33-.846.688-1.138A1.94 1.94 0 0 1 6.6 4H18l-.925 4H20l3 4-1 5h-2c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 17 20a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 14 17h-4c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 7 20Zm8.925-7h4.825l.1-.525L19 10h-2.375l-.7 3Zm-.475-6.825L15.5 6l-2.1 9 .05-.175.85-3.65 1.15-5ZM.5 13.325l.5-2h5.5l-.5 2H.5Zm2-3.65.5-2h6.5l-.5 2H2.5ZM7 18c.283 0 .52-.096.713-.288A.968.968 0 0 0 8 17a.968.968 0 0 0-.287-.712A.967.967 0 0 0 7 16a.967.967 0 0 0-.713.288A.968.968 0 0 0 6 17c0 .283.096.52.287.712.192.192.43.288.713.288Zm10 0c.283 0 .52-.096.712-.288A.968.968 0 0 0 18 17a.968.968 0 0 0-.288-.712A.968.968 0 0 0 17 16a.968.968 0 0 0-.712.288A.968.968 0 0 0 16 17c0 .283.096.52.288.712.191.192.429.288.712.288Z" />
        </svg>
    );
};

export default Shipping24;
